import {subscribe} from '@services/events';
import {eventType as wheelEventType,getNormalizedDelta} from '@services/events/wheel';
import $ from 'jquery';

let _disabled = false;

export function disabled(value){
  if(value === undefined) return _disabled;
  _disabled = Boolean(value);
  return _disabled;
}

export default function wheel({
  smooth = 5,
  completeThreshhold = .01,
  speed = 40,
  inertiaScrolling = true,
  onUpdate,
  setGlobal=false
} = {}){
  let destroyed=false;
  let isWheelMotion = false;

  let targetOffset = document.scrollingElement.scrollTop;
  let currentOffset = document.scrollingElement.scrollTop;

  const update = ()=>{
    const maxScroll = document.scrollingElement.scrollHeight - window.innerHeight;

    if(targetOffset > maxScroll){
      targetOffset = maxScroll;
    }
    if(targetOffset < 0){
      targetOffset = 0;
    }

    currentOffset += (targetOffset - currentOffset) / smooth;

    if(Math.abs(targetOffset - currentOffset)>completeThreshhold){
      if(inertiaScrolling && isWheelMotion){
        document.scrollingElement.scrollTop = currentOffset;
        onUpdate && onUpdate(currentOffset,maxScroll);
      }
      setGlobal&&document.documentElement.style.setProperty('--wheel-velocity',((targetOffset - currentOffset) / speed).toFixed(4));
    }else{
      isWheelMotion = false;
    }
  }

  if(inertiaScrolling){
    document.scrollingElement.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden'; // safari
  }

  const wheelListener = subscribe(document,wheelEventType,e=>{
    if($(e.target).parents('.has-wheel').length){
      return;
    }

    if(inertiaScrolling || _disabled){
      e.preventDefault();
      e.stopPropagation();
    }
    if(_disabled) return;

    const {spinY: delta} = getNormalizedDelta(e);
    targetOffset += delta * speed;
    isWheelMotion = true;
  },{ passive: false });

  const scrollListener = subscribe(document,'scroll',e=>{
    if(!isWheelMotion){
      targetOffset = document.scrollingElement.scrollTop;
    }
  });


  const tick = time => {
    !destroyed&&requestAnimationFrame(tick);
    update(time);
  }

  requestAnimationFrame(tick);

  return ()=>{
    destroyed = true;
    wheelListener();
    scrollListener();
  }
}